import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./styles.css";
import { useSelector } from "react-redux";
import KeywordTagsInput from "../KeywordTagsInput";

export default function FormModalMetier({ onClose, refresh, metierToUpdate, secteur }) {
    const [labelMetier, setLabelMetier] = useState("");
    const [iconMetier, setIconMetier] = useState(null);
    const [previewIcon, setPreviewIcon] = useState(null);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);
    const [keywords, setKeywords] = useState([]);

    useEffect(() => {
        if (metierToUpdate) {
            setLabelMetier(metierToUpdate.labelMetier || "");
            setPreviewIcon(
                metierToUpdate.iconMetier
                    ? `${apiUrl}/api/files/?categorie=metiers&file=${metierToUpdate.iconMetier}`
                    : null
            );
             // 🔥 récupérer les keywords
        fetch(`${apiUrl}/api/keyword/getByMetier?idMetier=${metierToUpdate.idMetier}`)
            .then(res => res.json())
            .then(data => {
                setKeywords(data.keywords || []);
            })
            .catch(err => console.error(err));

        } else {
            setLabelMetier("");
            setPreviewIcon(null);
        }
    }, [metierToUpdate, apiUrl]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("labelMetier", labelMetier);

        if (iconMetier) {
            formData.append("iconMetier", iconMetier);
        }
        if (secteur) {
            formData.append("idSecteur", secteur.idSecteur);
        }
        formData.append("keywords", JSON.stringify(keywords));

        const isUpdate = !!metierToUpdate;
        if (isUpdate) {
            formData.append("_method", "PUT"); // 🔁 même principe que pour secteur
        }

        try {
            const url = isUpdate
                ? `${apiUrl}/api/metiers/${metierToUpdate.idMetier}`
                : `${apiUrl}/api/metiers`;

            const response = await fetch(url, {
                method: "POST", // ⚠️ toujours POST
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    // pas de "Content-Type" → laissé à fetch
                }
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "Erreur sauvegarde métier ou service");

            alert(data.message || (isUpdate ? "Métier ou service mis à jour" : "Métier ou service créé"));
            refresh();
            onClose();
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };


    return (
        <div className="modal-overlay">
            <div className="modal">
                <button className="modal-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <h3>{metierToUpdate ? "Modifier le métier ou service" : "Ajouter un métier ou un service"}</h3>
                <form onSubmit={handleSubmit} className="form">
                    <div className="form-group">
                        <label>Nom du métier ou du service</label>
                        <input
                            type="text"
                            value={labelMetier}
                            onChange={(e) => setLabelMetier(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Icône du métier ou du service</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                setIconMetier(e.target.files[0]);
                                setPreviewIcon(URL.createObjectURL(e.target.files[0]));
                            }}
                        />
                        {previewIcon && (
                            <div className="preview">
                                <img src={previewIcon} alt="Aperçu" className="preview-icon" />
                            </div>
                        )}
                    </div>
                        <KeywordTagsInput
                            value={keywords}
                            onChange={setKeywords}
                            apiUrl={apiUrl}
                        />

                    <button type="submit" className="btn-submit">
                        {metierToUpdate ? "Mettre à jour" : "Créer"}
                    </button>
                </form>
            </div>
        </div>
    );
}
